import { useEffect, useState } from "react";

function PasswordRules({ password, message='Cadena'}) {
    const [firstRule, setFirstRule] = useState(false)
    const [secondRule, setSecondRule] = useState(false)
    const [thirdRule, setThirdRule] = useState(false)
    const [quarterRule, setQuarterRule] = useState(false)
    const [fifthRule, setFifthRule] = useState(false)




    const verify = () => {
        if(password === undefined  || password === null)return
        if(password.length && password.length === 0)return
        const passwordSplit = password.split("")
            if (passwordSplit.some(caracter=>/[A-Z]/.test(caracter))) {//mayusculas
                setSecondRule(true)
            }else{
                setSecondRule(false)
            }
            if (passwordSplit.some(caracter => /[a-z]/.test(caracter))) {//minusculas
                setThirdRule(true)
            }else{
                setThirdRule(false)

            }
            if (passwordSplit.some(caracter => /[1-9]/.test(caracter))) {//minusculas

            
                setFifthRule(true)
            }else{
                setFifthRule(false)

            }
            if (password.length >=8) {
                setFirstRule(true)
            }else{
                setFirstRule(false)
            }

            if (passwordSplit.some(caracter=>/[^A-Za-z0-9]/.test(caracter))) {
                setQuarterRule(true)
            }else{
                setQuarterRule(false)}
       


    }
    useEffect(()=>{
        verify()
    },[password, verify])
  return (
    <div className="main-div-pr">
        <p className="p-message-pr">
            {message} debe cumplir con las siguientes reglas:
        </p>

        <div className="secondary-div-pr">
            {/* primer regla */}
            <span
                className={`icon-span-rule-pr ${
                    firstRule ? "yes-rule-pr" : "no-rule-pr"
                }`}
            >
                <span className="span-icon-pr">
                    {firstRule ? "✓" : "•"}
                </span>
                Mínimo 8 caracteres
            </span>
            {/* 2da regla */}

            <span
                className={`icon-span-rule-pr ${
                    secondRule ? "yes-rule-pr" : "no-rule-pr"
                }`}
            >
                <span className="span-icon-pr">
                    {secondRule ? "✓" : "•"}
                </span>
                Mínimo 1 letra mayúscula
            </span>
            {/* 3er regla */}

            <span
                className={`icon-span-rule-pr ${
                    thirdRule ? "yes-rule-pr" : "no-rule-pr"
                }`}
            >
                <span className="span-icon-pr">
                    {thirdRule ? "✓" : "•"}
                </span>
                Mínimo 1 letra minúscula
            </span>
            {/* 4ta regla */}

            <span
                className={`icon-span-rule-pr ${
                    quarterRule ? "yes-rule-pr" : "no-rule-pr"
                }`}
            >
                <span className="span-icon-pr">
                    {quarterRule ? "✓" : "•"}
                </span>
                Mínimo 1 carácter especial
            </span>
            {/* 5ta regla */}

            <span
                className={`icon-span-rule-pr ${
                    fifthRule ? "yes-rule-pr" : "no-rule-pr"
                }`}
            >
                <span className="span-icon-pr">
                    {fifthRule ? "✓" : "•"}
                </span>
                Mínimo 1 número
            </span>
        </div>
    </div>
);
}

export default PasswordRules;